import React from 'react'
import { useCookies } from 'react-cookie'
import { useNavigate } from 'react-router-dom'
import classNames from 'classnames'

import { Button } from '../../../components/Button/Button'
import { useZocksAuth } from '../../../components/ScopedBlock/hooks'

import styles from './IntegrationUpgradeBanner.module.scss'

const _COOKIE_MAX_AGE = 60 * 60 * 24 * 365

export interface IntegrationUpgradeBannerProps {
  title: string
  description: string
  deltaTrialFeatureId: string
  hideCookieName: string
}

export const IntegrationUpgradeBanner: React.FC<IntegrationUpgradeBannerProps> = ({ title, description, deltaTrialFeatureId, hideCookieName }) => {
  const [cookies, setCookie] = useCookies()
  const navigate = useNavigate()
  const { hasScope } = useZocksAuth()
  const hasBillingSubscriptionChangePermission = hasScope('**', 'billing_subscription:change', ['billing_subscription:admin'])

  const handleHideBanner = () => setCookie(hideCookieName, true, { path: '/', maxAge: _COOKIE_MAX_AGE })

  if (cookies[hideCookieName]) {
    return null
  }

  return (
    <div className={classNames('d-flex gap-4 p-4 border zocks-border-color-primary-light', styles.banner)}>
      <div className='d-flex flex-column flex-1 gap-2'>
        <span className='paragraph-large bold zocks-text-gray-900'>{title}</span>
        <span className='paragraph-small zocks-text-gray-900'>{description}</span>
      </div>
      <div className='d-flex flex-column align-items-end justify-content-between flex-shrink-0'>
        <i className={classNames('bi bi-x cursor-pointer', styles.close)} onClick={handleHideBanner} />
        {hasBillingSubscriptionChangePermission ? (
          <div className='d-flex gap-2'>
            <Button variant='header' className='button-small' onClick={() => navigate(`/account/plan/free-trial/${deltaTrialFeatureId}`)}>
              Start free trial
            </Button>
            <Button variant='primary' className='button-small' onClick={() => navigate('/account/plan')}>
              Upgrade to Ultimate
            </Button>
          </div>
        ) : (
          <span className='paragraph-small zocks-text-gray-900'>Reach out to your Account Owner to request the trial.</span>
        )}
      </div>
    </div>
  )
}
